<template>
    <div :class="['BaseHero bg-cover bg-center bg-no-repeat', backgroundClass]" :style="backgroundStyle">
        <div class="container flex flex-col py-8 sm:mb-0 lg:py-16">
            <div class="flex flex-col-reverse items-center justify-between lg:flex-row">
                <div class="max-w-3xl lg:w-1/2">
                    <h1 class="mb-4 text-3xl font-bold text-white md:mb-8 md:text-5xl lg:leading-[65px]">
                        <slot name="title" />
                    </h1>
                    <CText class="mt-4 leading-[27.2px] text-white">
                        <slot name="message" />
                    </CText>
                    <div
                        v-if="slots.buttons"
                        class="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-x-10 lg:justify-start"
                    >
                        <slot name="buttons" />
                    </div>
                </div>
                <div>
                    <slot name="image" />
                </div>
            </div>
            <div v-if="slots.bottom" class="mt-6 lg:mt-8">
                <slot name="bottom" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const slots = useSlots()

const props = defineProps({
    backgroundClass: {
        type: String,
        default: ''
    },
    backgroundImage: {
        type: String,
        default: ''
    }
})

const backgroundStyle = computed(() => {
    if (props.backgroundImage) {
        return { backgroundImage: `url('${props.backgroundImage}')` }
    }
    return {}
})
</script>
